import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  text: {
    backgroundColor: theme.palette.yellow,
    paddingBottom: "2.5rem",
    margin: "0 auto",
    [theme.breakpoints.up('sm')]: {
      maxWidth: "21.4rem"
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: "45rem"
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: "53.5rem"
    },
  },
  simple: {
    '& p': {
      fontFamily: 'Roboto',
      height: "auto",
      margin: "auto 0",
      fontSize: "1.3rem",
      lineHeight: "1.6",
      letterSpacing: "0.0075rem",
    },
    '& h2': {
      fontSize: "3.5rem",
      margin: '0.8rem 0',
    },
    '& h3': {
      fontSize: "3rem",
      margin: '0.8rem 0',
    },
    '& h4': {
      fontSize: "2rem",
      margin: '0.8rem 0',
      lineHeight: "auto"
    },
  },
  intro: {
    '& p': {
      height: "auto",
      margin: "auto 0",
      fontSize: "2rem",
    },
    '& h2': {
      fontSize: "3.5rem",
      margin: '0.8rem 0',
    },
    '& h3': {
      fontSize: "3rem",
      margin: '0.8rem 0',
    },
    '& h4': {
      fontSize: "2rem",
      margin: '0.8rem 0',
      lineHeight: "auto"
    },
  },
  bullets: {
    '& ul': {
      color: theme.palette.purple,
      height: "auto",
      fontSize: "2rem",
      listStyle: "disc",
      margin: "0",
      [theme.breakpoints.up('md')]: {
        paddingLeft: "14rem",
      },
    }
  },
  quote: {
    '& p': {
      height: "auto",
      fontSize: "2rem",
      color: theme.palette.purple,
      textAlign: "center",
      margin: "0 auto",
      [theme.breakpoints.up('sm')]: {
        maxWidth: "39.6rem"
      },
      [theme.breakpoints.up('md')]: {
        maxWidth: "21.37rem"
      },
      [theme.breakpoints.up('lg')]: {
        maxWidth: "39.6rem"
      },
    },
  }
}));
